export const OptmumMood = {
  astonised: require('./optimum_astonished.png'),
  smiley: require('./optimum_smiley.png'),
  normal: require('./optimum_normal.png'),
  excited: require('./optimum_excited.png'),
  thinking: require('./optimum_thinking.png'),
  confetti: require('./optimum_confetti.png'),
}
